export default __webpack_public_path__ + "static/media/M_Insta_Dark.dc10a8e6.svg";